/**
 * FilterSelect class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { DataTableSelectType } from 'Types';
import CustomSelect from 'Common/CustomSelect';

export default class FilterSelect extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        options: PropTypes.arrayOf(DataTableSelectType),
        filter: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
        setFilter: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        libraryParams: PropTypes.object,
        id: PropTypes.string,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        libraryParams: {},
        filter: null,
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const { filter, setFilter, libraryParams, options, ...SelectParams } = this.props;

        return <CustomSelect
            {...libraryParams}
            {...SelectParams}
            options={[{value: null, label: this.context.intl.formatMessage({id: 'data_table.none'})}, ...options]}
            value={filter}
            onChange={setFilter}
        />;
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFilters/Filters/FilterSelect.jsx